var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.display !== "none"
    ? _c(
        "div",
        {
          staticClass: "cog-page-progress",
          class: [
            {
              "cog-page-progress--compact": _vm.isNarrow,
              "cog-page-progress--at-end": _vm.onLastPage
            },
            "cog-page-progress--" + _vm.display
          ],
          attrs: {
            id: !_vm.isExpandable ? null : _vm.id,
            "aria-expanded": !_vm.isExpandable
              ? null
              : _vm.verticalBarsExpanded
              ? "true"
              : "false",
            "data-backwards": _vm.backwards
          }
        },
        [
          _c(
            "el-scrollbar",
            { attrs: { tag: "ol" } },
            _vm._l(_vm.pages, function(page, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "cog-page-progress__page",
                  class: [
                    {
                      "is-active": page === _vm.currentPage,
                      "is-disabled": _vm.cantGoBack(index),
                      "cog-page-progress__page--no-title": !page.title
                    },
                    _vm.scrollingStepsShiftClass
                  ],
                  attrs: { "data-title": page.title }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.cantGoBack(page.number) ? false : "",
                        title: _vm.isNarrow ? page.title : false,
                        "data-page-number": index + 1
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.goto(page.number, $event)
                        },
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar"
                            ])
                          )
                            return null
                          $event.preventDefault()
                          return _vm.goto(page.number)
                        }
                      }
                    },
                    [
                      _vm.showTitles
                        ? _c(
                            "span",
                            { staticClass: "cog-page-progress__page-title" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("preventSingleCharWidow")(page.title)
                                )
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.isExpandable
            ? _c("div", { staticClass: "cog-wrapper" }, [
                _c(
                  "button",
                  {
                    staticClass: "cog-page-progress__expand-button",
                    attrs: {
                      title: _vm.verticalBarsExpanded
                        ? _vm.$resource("collapse")
                        : _vm.$resource("expand"),
                      "aria-controls": _vm.id
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleCollapse()
                      }
                    }
                  },
                  [_c("i-chevron")],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }